export default __webpack_public_path__ + "static/media/a20.6d14d40c.jpg";